<style>
  .autocomplete-fix-width300 {
    width: 300px !important;
  }
</style>

<div class="modal-header">
  <h4 class="modal-title pull-left">Properties</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="onClose($event)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="banner-subpage">
  <div class="search-div advanced-search-div clearfix search-div-02 buy-page-advance-search">
    <div class="advanced-search-inner">
      <!--<be-property-search (propertySearchCriteria)="propertySearchCriteria($event)"></be-property-search>-->
      <div class="form-group bigdiv location-auto-complete " [ngClass]="{'autocomplete-fix-width300':includeBOV}">

        <mat-form-field class="mat-no-border select-highlight mobile-change-select matautocomplete">
          <input matInput
                 placeholder="Tenant, Address, City, State"
                 [matAutocomplete]="auto"
                 [(ngModel)]="searchCriteria.Address"
                 (input)="dataServiceInput$.next($event.target.value)" />

          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPropertyAutocompleteSelect($event.option.value)">

            <ng-container *ngIf="dataService$ | async as items">
              <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                          [value]="item">
                <div class="split-container">
                  <span>{{ item.PropertyName }}</span>
                  <span class="location-type">{{ item.Type }}</span>
                </div>
              </mat-option>
            </ng-container>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="form-group smalldiv pricediv clearfix">
        <div class="btn-group select-dropdown clearfix right-border" dropdown>
          <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
            Price <span class="caret"></span>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
            <div class="form-group margin0">
              <div class="row">
                <div class="resp-col margin-bottom-15">
                  <div class="textbox-with-btn-left">
                    <input inputmode="numeric" type="text" class="search-field-input form-control"
                           mask="separator.10" thousandSeparator="," maxlength="15"
                           [(ngModel)]="searchCriteria.PriceFrom" placeholder="- Min -" />
                    <span class="leftlabel">$</span>
                  </div>
                  <!--<span class="minusspan">-</span>-->
                </div>
                <div class="resp-col">
                  <div class="textbox-with-btn-left">
                    <input type="text" inputmode="numeric" class="search-field-input form-control"
                           maxlength="15" mask="separator.10" thousandSeparator=","
                           [(ngModel)]="searchCriteria.PriceTo" placeholder="- Max -" />                  <span class="leftlabel">$</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group smalldiv">
        <div class="select-dropdown right-border multiselectdesign">
          <mat-form-field class="mat-no-border select-highlight mobile-change-select property-type-form" style="margin-bottom: -10px;">
            <mat-select placeholder="Property Type"
                        panelClass="dynamic-width"
                        [(ngModel)]="searchCriteria.AssetTypes"
                        multiple>
              @if (searchCriteria.AssetTypes?.length > 1) {
              <mat-select-trigger>
                <span>{{ searchCriteria.AssetTypes?.length }} items selected</span>
              </mat-select-trigger>
              }
              @for (asset of inputAssetTypes; track asset) {
              <mat-option [value]="asset.id" class="multi-dropdown-item">{{asset.name}}</mat-option>
              }
              @if (inputAssetTypes.length === 0) {
              <mat-option class="matoptionnodata" disabled>
                Nothing found...
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group smalldiv clearfix" *ngIf="includeBOV">
        <div class="select-dropdown right-border multiselectdesign">
          <mat-form-field class="mat-no-border select-highlight mobile-change-select" style="margin-bottom: -10px;">
            <mat-select placeholder="Property Status"
                        panelClass="dynamic-width"
                        [(ngModel)]="searchCriteria.PropertyStatus"
                        multiple>
              @if (searchCriteria.PropertyStatus?.length > 1) {
              <mat-select-trigger>
                <span>{{ searchCriteria.PropertyStatus?.length }} items selected</span>
              </mat-select-trigger>
              }
              @for (status of inputPropertyStatus; track status) {
              <mat-option [value]="status.id" class="multi-dropdown-item">{{status.name}}</mat-option>
              }
              @if (inputPropertyStatus.length === 0) {
              <mat-option class="matoptionnodata" disabled>
                Nothing found...
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="form-group smalldiv pricediv clearfix">
        <div class="btn-group select-dropdown clearfix right-border" dropdown>
          <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
            Cap Rate <span class="caret"></span>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
            <div class="form-group margin0">
              <div class="row">
                <div class="resp-col margin-bottom-15">
                  <div class="textbox-with-4character textbox-with-2character textbox-with-btn">
                    <input inputmode="decimal" (keydown)="onInputKeyPress($event);" type="text" class="search-field-input form-control"
                           mask="999.99" [dropSpecialCharacters]="false"
                           [(ngModel)]="searchCriteria.CapRateFrom"
                           placeholder="- Min -" (change)="validateFilters()">
                    <span class="rightlabel">%</span>
                  </div>
                </div>
                <div class="resp-col">
                  <div class="textbox-with-4character  textbox-with-2character textbox-with-btn">
                    <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" [dropSpecialCharacters]="false" mask="999.99" [(ngModel)]="searchCriteria.CapRateTo" placeholder="- Max -" (change)="validateFilters()">
                    <span class="rightlabel">%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--<div class="form-group smalldiv">
          <div class="select-dropdown right-border multiselectdesign select-check">
              <ss-multiselect-dropdown [options]="inputTenants" [(ngModel)]="searchCriteria.Tenants" [settings]="defaultTenantSettings" [texts]="defaultTenantText" #dropdownTenants></ss-multiselect-dropdown>
          </div>
      </div>-->
      <!--<div class="form-group smalldiv">
          <div class="select-dropdown right-border multiselectdesign">
              <ss-multiselect-dropdown [options]="inputRatings" [(ngModel)]="searchCriteria.Ratings" [settings]="defaultCreditSettings" [texts]="defaultCreditText"></ss-multiselect-dropdown>
          </div>
      </div>-->
      <!--<div class="form-group smalldiv">
          <div class="select-dropdown right-border multiselectdesign">
              <ss-multiselect-dropdown [options]="inputTerms" [(ngModel)]="searchCriteria.Terms" [settings]="defaultTermSettings" [texts]="defaultTermText"></ss-multiselect-dropdown>
          </div>
      </div>-->
      <div class="form-group smalldiv">
        <div class="btn-group select-dropdown clearfix right-border" dropdown>
          <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
            Term <span class="caret"></span>
          </button>
          <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
            <div class="form-group margin0">
              <div class="row">
                <div class="resp-col margin-bottom-15">
                  <div class="textbox-with-4character textbox-with-btn">
                    <input type="text" class="search-field-input form-control" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" maxlength="15" [(ngModel)]="searchCriteria.MinTerm" placeholder="- Min -" value="{{searchCriteria.MinTerm}}" />
                    <span class="rightlabel">Years</span>
                  </div>
                </div>
                <div class="resp-col">
                  <div class="textbox-with-4character textbox-with-btn">
                    <input type="text" class="search-field-input form-control" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" maxlength="15" [(ngModel)]="searchCriteria.MaxTerm" placeholder="- Max -" value="{{searchCriteria.MaxTerm}}" />
                    <span class="rightlabel">Years</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="searchbtn mr-4px" (click)="onPropertySearch()">Search</button>
      <a href="javascript:void(0);" class="btn-icon01" (click)="onResetClick()">
        <i aria-hidden="true" class="icon-reset"></i>
        Reset
      </a>
    </div>
  </div>
</div>
<div class="modal-body table-fixed margin-top-20">
  <div class="table-responsive margin-bottom-20">
    <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
      <thead>
        <tr>
          <th class="remove" style="position:static; cursor:auto;">Select</th>
          <th>OM</th>
          <th class="property-name-column">Tenant</th>
          <th>State</th>
          <th>Listing Type</th>
          <th>Property Type</th>
          <th>Property Status</th>
          <th>Asking Price</th>
          <th>Rent NOI</th>
          <th>Credit Rating</th>
          <th>Cap Rate</th>
          <!--<th [hidden]="!isPropertyForSale">Remaining Term</th>-->
          <th>Remaining Term</th>
          <th>Lease Structure</th>
          <th>Area (SQ FT)</th>
          <!--<th style="width:60px">Action</th>-->
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let prop of propertySuggestList">
          <td>
            <label class="custom-checkbox withoutlabel">
              <input [disabled]="prop.DisabledSelection || (prop.PortfolioPropertyId != null && prop.PortfolioPropertyId > 0 && prop.PortfolioPropertyId != this.propertyId)" type="checkbox" [(ngModel)]="prop.IsChecked" (ngModelChange)="onChecked(prop);">
              <i></i>
            </label>
          </td>
          <td>
            <span *ngIf="prop.OMFilePath == null">-</span>
            <a *ngIf="prop.OMFilePath!=null" href={{prop.OMFilePath}} download="Document.pdf" target="_blank" [ngClass]="{'border-link':(prop.OMFilePath!=null)}">
              <i *ngIf="prop.OMFilePath!=null" aria-hidden="true" class="icofont icofont-download-alt downloadicon"></i>{{prop.OMFilePath!=null?'OM':'-'}}
            </a>
          </td>
          <!--<td><a href="#" routerLink="/viewproperty/{{prop.Guid}}"><img class="property-image" src="{{prop.FilePath != null ? prop.FilePath : 'assets/img/default-property_1.png'}}" /></a></td>-->
          <td class="min-width-td">
            <p>
              <a target="_blank" href="#" routerLink="/viewproperty/{{prop.Guid}}" *ngIf="!isDataEntryProperty">{{ prop.PropertyName }}</a>
              <a target="_blank" href="#" routerLink="/viewdeproperty/{{prop.Guid}}" *ngIf="isDataEntryProperty">{{ prop.PropertyName }}</a>
            </p>
            <sub>{{prop.PropertySequenceId}}</sub>
          </td>
          <!--<td><p><a href="javascript:void(0);" [ngClass]="{'favClicked':(prop.IsFav === 1)}"  tooltip="Add to favourite" placement="left" (click)="addToFav(prop.Id);"><i class="fa fa-heart icon"></i></a></p></td>
          <td><p><a href="javascript:void(0);" [ngClass]="{'label1031-checked':(prop.Is1031Exchange === 1)}" tooltip="Add to 1031Exchange" placement="left" (click)="open1031ExchangeModal(template1031,'panlestyle',prop.Id);">
              <i class="fa fa-plus-circle icon" aria-hidden="true"></i></a></p></td>-->
          <td><p>{{ prop.State ? prop.State : '-' }}</p></td>
          <td><p>{{prop.PropertyFor}}</p></td>
          <td><p tooltip="{{prop.AssetType}}">{{ prop.AssetType ? _commonService.GetPropertyTypeWithCount(prop.AssetType) : '-' }}</p></td>
          <td><p [ngClass]="{'redtextlabel':(prop.PropertyStatus === 'Closed' || prop.PropertyStatus === 'Sold' || prop.PropertyStatus === 'Not Available' || prop.PropertyStatus === 'Off-Market'),'greentextlabel':prop.PropertyStatus === 'Available','orangetextlabel':prop.PropertyStatus === 'Under Contract'}">{{ prop.PropertyStatus }}</p></td>
          <td>
            <p class="whitespacenowrap" *ngIf="prop.Unpriced">Unpriced</p>
            <p class="whitespacenowrap" *ngIf="!prop.Unpriced">{{(prop.Price!=null&&prop.Price>=0 && prop.IsShowPrice) ? '$ '+(prop.Price |number:0) : '-'}}</p>
          </td>
          <td><p class="whitespacenowrap">{{ (prop.RentNOI) ? '$ '+(prop.RentNOI | number:0) : '-' }}</p></td>
          <td><p>{{ prop.RatingType ? prop.RatingType + (prop.Rating ? ' (' + prop.Rating + ')' : '') : '-' }}</p></td>
          <td>
            <p *ngIf="prop.CharacteristicsId == 1">ZCF</p>
            <p *ngIf="prop.CharacteristicsId == 0">{{ (prop.CapRate && prop.IsShowPrice) ? (prop.CapRate | number : '1.2-2') + '%' : '-'}}</p>
          </td>
          <td><p class="whitespacenowrap">{{ prop.RemainingTerm ? (prop.RemainingTerm | yearsMonthConverter:true) : '-'}}</p></td>
          <td><p class="whitespacenowrap">{{ prop.LeaseStructure ? prop.LeaseStructure : '-'}}</p></td>
          <td><p>{{ prop.BuildingSize ? (prop.BuildingSize |number:0) : '-' }}</p></td>
          <!--<td class="whitespacenowrap">
              <div *ngIf="!showDisLike">
                  <a triggers="hover" href="javascript:void(0);" [ngClass]="{'favlinkintable':(prop.IsFav === 0),'favlinkintableactive':(prop.IsFav === 1)}" tooltip="{{prop.IsFav == 1 ? 'Remove from Liked list':'Like'}}" placement="top" container="body" (click)="addToFav(prop.Id);"><i class="fa fa-thumbs-o-up icon"></i></a>
                  <a class="favlinkintable" href="javascript:void(0);" triggers="hover" [ngClass]="{'favlinkintable': (prop.Is1031Exchange === 0), 'favlinkintableactive': (prop.Is1031Exchange === 1)}"
                     [tooltip]="prop.Is1031Exchange === 0 ? 'Add trade portfolio': 'Change trade portfolio'" placement="top" container="body" (click)="open1031ExchangeModal(template1031,'panlestyle',prop);">
                      <i class="fa fa-plus-circle icon" aria-hidden="true"></i>
                  </a>
              </div>
              <div *ngIf="showDisLike">
                  <a *ngIf="prop.IsDisliked != 1" triggers="hover" href="javascript:void(0);" [ngClass]="{'favlinkintable':(prop.IsFav === 0),'favlinkintableactive':(prop.IsFav === 1)}" [class]="classToBind" tooltip="{{prop.IsFav == 1 ? 'Remove from Liked list':'Like'}}" placement="top" container="body" (click)="addToFav(prop.Id);">
                      <i class="fa fa-thumbs-o-up icon"></i>
                  </a>
                  <a class="favlinkintable" href="javascript:void(0);" triggers="hover" [ngClass]="{'favlinkintable': (prop.Is1031Exchange === 0), 'favlinkintableactive': (prop.Is1031Exchange === 1)}"
                     [class]="classToBind1031" [tooltip]="prop.Is1031Exchange === 0 ? 'Add trade portfolio': 'Change trade portfolio'" placement="top" container="body" (click)="open1031ExchangeModal(template1031,'panlestyle',prop);">
                      <i class="fa fa-plus-circle icon" aria-hidden="true"></i>
                  </a>
                  <a *ngIf="prop.IsFav != 1" triggers="hover" href="javascript:void(0);" [ngClass]="{'showDisLike && favlinkintable':(prop.IsDisliked === 0),'favlinkintableactive':(prop.IsDisliked === 1)}" [class]="classToBindDislike" tooltip="{{prop.IsDisliked == 1 ? 'Remove from Disliked list':'Dislike'}}" placement="top" container="body" (click)="addToDisliked(prop.Id);">
                      <i class="fa fa-thumbs-o-down icon"></i>
                  </a>
              </div>
          </td>-->
        </tr>
        <tr *ngIf="(propertySuggestList==null || propertySuggestList?.length === 0)&&!IsLoading">
          <td colspan="12" class="no-data-available">
            <div class="nodata">
              <i class="fa fa-exclamation-triangle icon"></i>
              <p>No Data Available</p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


  <div class="text-right" style="padding-bottom:30px;">
    <button class="btn btn-lg btn-default " (click)="onClose($event)">Cancel</button>
    <button class="btn btn-success btn-lg" (click)="onAdd($event);">Add</button>
  </div>

</div>



